var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 125,
    viewBox: "0 0 119 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3036 34.0363C92.3036 53.9836 77.4854 72.8331 59.2029 72.8331C40.9204 72.8331 26.0977 53.9843 26.0977 34.0363C26.0977 14.0853 40.9186 0.589844 59.2029 0.589844C77.4854 0.589844 92.3036 14.0834 92.3036 34.0363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8478 71.629C82.0875 80.7417 71.4862 86.6733 59.79 86.6733C47.8921 86.6733 37.1205 80.5347 29.3242 71.1509C11.7829 81.8376 -0.000488281 101.642 -0.000488281 124.318H118.396C118.395 101.98 106.962 82.4211 89.8478 71.6281V71.629Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.802b122ce15c96a80ccf8b0b4f364da0.svg";
export { ForwardRef as ReactComponent };